var _defs, _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShipping(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Group_959",
    width: 44.319,
    height: 44.319,
    viewBox: "0 0 44.319 44.319",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .cls-4{fill:#d5d5d5}.cls-2,.cls-6{fill:none}.cls-2,.cls-3,.cls-4{stroke:#000}.cls-3{fill:#fff}.cls-5{stroke:none}\r\n        "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_63",
    cx: 22.16,
    cy: 22.16,
    r: 22.16,
    fill: "#d5d5d5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_358",
    transform: "translate(9.021 14.661)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_81",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H12.746V12.746H0z",
    className: "cls-5",
    transform: "translate(6.149)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0.5H12.246V12.246H0.5z",
    className: "cls-6",
    transform: "translate(6.149)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    d: "M-11548.5-17035h4.043l2.341 3.309v4.76h-6.384",
    className: "cls-2",
    transform: "translate(11567.183 17038.932)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    d: "M-11548.5-17009h6.384",
    className: "cls-3",
    transform: "translate(11567.183 17016.334)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    d: "M-11548.5-17009h3.547",
    className: "cls-3",
    transform: "translate(11548.5 17015.34)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    d: "M-11548.5-17009h3.547",
    className: "cls-3",
    transform: "translate(11548.5 17012.93)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    d: "M-11548.5-17009h3.547",
    className: "cls-3",
    transform: "translate(11548.5 17017.754)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_56",
    className: "cls-4",
    transform: "translate(19.645 10.497)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.249,
    cy: 2.249,
    r: 2.249,
    className: "cls-5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.249,
    cy: 2.249,
    r: 1.749,
    className: "cls-6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_57",
    className: "cls-4",
    transform: "translate(9.897 10.497)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.249,
    cy: 2.249,
    r: 2.249,
    className: "cls-5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.249,
    cy: 2.249,
    r: 1.749,
    className: "cls-6"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipping);
export default __webpack_public_path__ + "static/media/shipping.e0c936161f5c1eae3c27fea65f0fa065.svg";
export { ForwardRef as ReactComponent };